<template>
  <div>
    <div class="flex-1 overflow-hidden">
      <slot name="top"></slot>
      <template v-for="(e, i) in count" :key="i">
        <transition-group :name="transitionName">
          <div v-show="i == currentIndex" :key="i" :class="maybeHidden(i)">
            <slot :name="'item-' + i"></slot>
          </div>
        </transition-group>
      </template>
    </div>
    <div v-if="hasLabel" class="flex items-start -space-x-8">
      <div class="flex-1 overflow-hidden" >
        <!-- label-->
        <div  class="flex w-full items-end justify-center" >
          <div class="md:absolute bottom-0 md:right-0 w-full z-10">
            <div class="flex justify-center md:justify-end md:mr-16">
              <div class="bg-honey w-full md:w-96 p-8 text-white">
                <template v-for="(e, i) in count" :key="i">
                  <div v-show="i == currentIndex">
                    <slot :name="'label-' + i"></slot>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-center mt-2">
      <div class="z-20">
        <button @click="handlePrevious" class="text-primary text-3xl font-semibold" aria-label="go back"><i class="fas fa-chevron-left fa-fw fa-sm"></i></button>
      </div>
      <div class="z-20">
        <button @click="handleNext" class="text-primary text-3xl font-semibold" aria-label="next"><i class="fas fa-chevron-right fa-fw fa-sm"></i></button>
      </div>
    </div>
<!--    <div :id="thumbnailContainerId()" v-if="hasImages" class="flex  mt-2 overflow-x-scroll h-full">-->
<!--      <div class="flex flex-grow-0 flex-shrink-0">-->

<!--        <template v-for="(e, i) in count" :key="i">-->
<!--          <div @click="handleThumbnailClick(i)" :id="thumbnailId(i)">-->
<!--            <div :class="maybeActive(i)">-->
<!--              <slot :name="'item-image-' + i"></slot>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
<!--      </div>-->
<!--    </div>-->
  </div>

</template>

<script>
import slide from '../mixins/slide'
import VueScrollTo from 'vue-scrollto';
import debounce from 'lodash/debounce';
import _ from "lodash";
const options = {
  easing: 'ease-in',
  lazy: false,
  offset: 0,
  force: false,
  cancelable: true,
  onStart: function(element) {
    // scrolling started
  },
  onDone: function(element) {
    // scrolling is done
  },
  onCancel: function() {
    // scrolling has been interrupted
  },
  x: true,
  y: false
}
let previousIndex = null;
export default {
  name: "Carousel",
  mixins: [slide],
  props: {
    'hasLabel': {
      type: Boolean,
      default: false
    },
    'hasImages': {
      type: Boolean,
      default: false
    },
    'startingIndex': {
      type: Number,
      default: 0
    }
  },
  watch: {
    startingIndex(newIndex, oldIndex) {
      if (newIndex !== oldIndex)
        this.goto(newIndex);
    },
    currentIndex(newIndex, oldIndex) {
      if(this.hasImages){
        this.indexChange(newIndex);
      }
    },
    isVisible(now, previous){
      if(now && !previous){
        this.startInterval();
      } else if(!now && previous){
        this.stopInterval();
      }
    }
  },
  data() {
    return {
      cancelScroll: null,
      isVisible: false,
      observer: null,
      uId: Math.random().toString(36).substring(7)
    };
  },
  computed: {
    supportsIntersection() {
      return window['IntersectionObserver'];
    },
    scrollOptions(){
      return Object.assign(options,
          {container: "#" + this.thumbnailContainerId()});
    }
  },
  mounted() {
    // If IntersectionObservers are possible, utilize them to delay loading
    if(this.supportsIntersection){
      this.observe();
    }
  },

  beforeUnmount() {
    // If IntersectionObservers are possible, destroy the current instance
    // Otherwise, null out
    this.supportsIntersection ?
        this.unobserve() :
        null;
  },
  methods: {
    maybeHidden(index){
      if(index !== this.currentIndex){
        return "hidden";
      }
      return '';
    },
    maybeActive(index){
      if(index !== this.currentIndex){
        return "opacity-50 hover:opacity-100 cursor-pointer";
      }
      return '';
    },
    handleThumbnailClick(index){
      this.goto(index);

    },
    handleNext(){
      this.next();

    },
    handlePrevious(){
      this.previous();

    },
    thumbnailId(index){
      return 'thumbnail-' + this.uId  + "-" + index;
    },
    thumbnailContainerId(){
      return "thumbnail-container-" + this.uId;
    },
    indexChange: _.debounce(function (){
      VueScrollTo.scrollTo("#" + this.thumbnailId(this.currentIndex), 500, this.scrollOptions);
    }, 500),
    observe() {
      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          // Mark if the current element is visible or not
          this.isVisible = entry.isIntersecting;
        });
      }, {
        root: null,
        threshold: 0,
      });
      this.observer.observe(this.$el);
    }
  }
}
</script>